import { ModalState } from 'kinetic-angular';
import { CustomerSupportState, CustomerData } from './definition/customer-support.interface';
import { CssClass, ModalButtonId } from '../../services/shared/shared-enums';
export class CustomerSupportFactory 
{
	public static build(): CustomerSupportState 
	{ 
		return {
			pageHeading: '',
			startCTA: {
				size: 'large',
				style: 'primary',
				disabled: true,
				label: '',
				position: 'none',
				icon: { iconPath: '', altText: '' }
			},
			title: '',
			email: '',
			description: '',
			startSession: '',
			modalNote: '',
			loading: false,
			emailErrorMessage: '',
			isInvalid: false
		};
	}

	public static buildconfirmSession(): ModalState 
	{
		return {
			hidden: true,
			label: 'Impersonate User',
			buttons: [
				{ label: '', disabled: false, cssClass: CssClass.btnSecondary, iconPath: '', id: ModalButtonId.cancel },
				{ label: '', iconPath: '', disabled: false, cssClass: CssClass.btnBlack, id: ModalButtonId.proceed }
			],
			cssClass: ''
		};
	}
	public static buildUserData(): CustomerData 
	{
		return {
			email: '',
			name: '',
			role: ''
		};
	}

}
